import React from 'react';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import './css/App.css';
import Header from './componentes/header';
import Menu from './componentes/menu';
import Home from './secciones/home';
import AcercaDe from './secciones/acercade';
import Licencias from './secciones/licencias';
import Contacto from './secciones/contacto';
import Cargaproyectos from './secciones/cargaproyectos';
import Proyecto from './secciones/proyecto';

function App() {		

	// ver https://muffinman.io/react-router-subfolder-on-server/

  return (
	<Router basename="/hackaton3d/" >
    <div className="bmd-layout-container bmd-drawer-f-l bmd-drawer-overlay">
    	<Header />
  		<Menu />
		<main className="bmd-layout-content">
			<div className="container mt-4">
				
				<Switch>
					<Route exact path="/">
						<Home />
					</Route>
					<Route path="/acercade">
						<AcercaDe />
					</Route>
					<Route path="/licencias">
						<Licencias />
					</Route>
					<Route path="/contacto">
						<Contacto />
					</Route>
					<Route path="/cargaproyectos">
						<Cargaproyectos />
					</Route>
					<Route path="/proyecto/:id">
						<Proyecto />
					</Route>
				</Switch>

			</div>
		</main>
	</div>
	</Router>
  );
}

export default App;
